import React from "react";
import Header from "../components/Header";

const About = () => {
  return (
    <div className="wrap2">
      <Header />
      <div className="container">
        <div>
          <h5>About Us</h5>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima,
            quae dolor aliquam nulla error sequi placeat numquam sed consequatur
            ea hic odit, sit minus enim voluptas. Commodi laboriosam maxime
            placeat praesentium nesciunt libero, unde sequi voluptatem enim
            ullam necessitatibus magnam at dolorem beatae tempora, ad magni
            repellendus doloribus, animi maiores.
          </p>
          <p className="dark">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
            dolores nobis suscipit sapiente nisi ratione eius quaerat harum
            voluptate, dignissimos reiciendis vero numquam laudantium iste
            aspernatur. Odit eligendi maiores commodi. Lorem, ipsum dolor sit
            amet consectetur adipisicing elit. Quia laudantium rerum quos unde
            sunt cumque quaerat quis recusandae? Dolorum, ullam molestias!
            Aliquam aspernatur sint in id culpa sed harum quaerat!
          </p>
        </div>
        <div>
          <div className="dark">
            <h5>What We Do</h5>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque
              incidunt cupiditate dolorum voluptatem ipsum iusto reiciendis
              nulla porro, eos non harum sunt facilis reprehenderit. Repudiandae
              saepe quisquam accusamus similique est!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
